import validateSequence from "./validateSequence.js";
export default function validateSequenceArray(parsingResultArray, options) {
  if (parsingResultArray) {
    if (!Array.isArray(parsingResultArray)) {
      parsingResultArray = [parsingResultArray];
    }
    parsingResultArray.forEach(function(parsingResult) {
      if (parsingResult.success) {
        const res = validateSequence(parsingResult.parsedSequence, options);
        parsingResult.messages = parsingResult.messages.concat(res.messages);
        parsingResult.parsedSequence = res.validatedAndCleanedSequence;
      }
    });
  }
  return parsingResultArray;
}
